'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = { each: _each3.default };

var _module = _angular2.default.module('cb.ui-components.content-filter.content-filter-controller', []);

_module.controller('ContentFilterController', ContentFilterController);

exports.default = _module;
/**
 * Content Filter
 *
 * @requires:
 *  - cb-content-filter-category
 *  - cb-content-filter-item
 *
 *  This directive can be used to display content after a button press. Multiple elements are
 *  allowed to be linked to a category with the cb-content-filter-item directive.
 *  Content can therefore be split up more easily across the page.
 *
 *  There are two different modes
 *  1. Switch content (default)
 *  2. Toggle content
 *
 *  The default mode works like tabs. Only one category can be active at a time
 *  The Toggle mode, can be used by setting the attribute 'cb-enable-filter-toggle'
 *  on the same element as 'cb-content-filter'
 *
 **/

function ContentFilterController() {
    var vm = this;
    var categories = {};

    var toggleEnabled = false;

    vm.registerCategory = registerCategory;
    vm.setActive = setActive;
    vm.isActive = isActive;

    function registerCategory(name) {
        if (typeof categories[name] !== 'undefined') {
            throw new Error('cb-content-filter: Trying to register category with duplicate name');
        }

        categories[name] = false;
    }

    function setActive(name) {
        if (toggleEnabled) {
            toggleCategory(name);
        } else {
            switchCategory(name);
        }
    }

    function isActive(name) {
        return categories[name];
    }

    function toggleCategory(name) {
        _.each(categories, function (value, key) {
            if (key === name) {
                categories[key] = !categories[key];
            }
        });
    }

    function switchCategory(name) {
        _.each(categories, function (value, key) {
            categories[key] = key === name;
        });
    }

    vm.$onInit = function () {
        if (typeof vm.cbEnableFilterToggle !== 'undefined') {
            toggleEnabled = true;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/content-filter/cb-content-filter.controller.js
// module id = 880
// module chunks = 0